module.exports = __webpack_public_path__ + "static/media/directions_zh@2x.0d574de8.png";